import React from 'react';
import PropTypes from 'prop-types';
import { ButtonLayout, ButtonStandard, Text } from '@stashinvest/react-components';
import { BanjoString } from '@stashinvest/react-banjo';

/**
 * This custom error screen will not appear in the web app until
 * the Plaid SDK is updated to no longer display the iframed "No compatible accounts" screen.
 */
const NoAccountsError = ({ linkAnotherBank, cancel }) => {
	return (
		<>
			<Text textStyle="headerSmall" className="mb-contentSmall">
				<BanjoString stringId="information/inform/accountsNotFound" />
			</Text>
			<Text textStyle="bodyMediumStandard" className="mb-contentSmall">
				<BanjoString stringId="information/giveContext/linkExternalBankAccount" />
			</Text>
			<ButtonLayout variant="stackVertical">
				<ButtonStandard
					size="XL"
					variant="primary"
					onClick={() => {
						linkAnotherBank();
					}}
				>
					<BanjoString stringId="action/startTask/linkOtherExternalBank" />
				</ButtonStandard>
				<ButtonStandard size="XL" variant="secondary" onClick={() => cancel()}>
					<BanjoString stringId="action/escape/cancel" />
				</ButtonStandard>
			</ButtonLayout>
		</>
	);
};

NoAccountsError.propTypes = {
	linkAnotherBank: PropTypes.func,
	cancel: PropTypes.func,
};

export default NoAccountsError;
